const appRoutes = {

    homePageRoute: '/',
    registerPageRoute: '/register',
    loginPageRoute: '/login',
    thankYouPageRoute: '/thank-you',
    otpPageRoute: '/otp',
    verifyEmailPageRoute: '/verify-email',
    forgotPasswordPageRoute: '/forgot-password',
    profilePageRoute: '/profile',
    updatePageRoute: '/user/password/update',
    /**Page url */
    notificationPageRoute: '/page/notification',

    pdfEditorPageRoute: '/create-proposal',
    pdfEditorUpdatePageRoute: '/update-proposal',

    listProposalRoute: '/proposal-list',
    resetPasswordRoute: '/reset-password',
    proposalInfo: '/proposal-info',
    testDoc: '/test-doc',



    





}
export default appRoutes